import { RenderIf } from 'components/RenderIf'
import { useMyDispatch } from 'featureSliced/shared/hooks/useMyDispatch'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { FC, useEffect } from 'react'
import { ToastsSlice } from 'featureSliced/shared/store/reducers/ToasterReducer'
import { IToast } from 'featureSliced/shared/store/reducers/ToasterReducer/types'
import { ToastContainer, ToastsContainer } from './styled'
import { ReactComponent as ICircle } from 'assets/toasters/iCircle.svg'
import { ReactComponent as Cross } from 'assets/toasters/cross.svg'

export const Toaster = () => {
  const toasts = useMySelector((state) => state.toasts)

  return (
    <RenderIf condition={!!toasts?.length}>
      <ToastsContainer>
        {toasts?.map((toast) => (
          <ToastItem key={`TOAST_${toast.id}`} toast={toast} />
        ))}
      </ToastsContainer>
    </RenderIf>
  )
}

const ToastItem: FC<{ toast: IToast }> = ({ toast }) => {
  const dispatch = useMyDispatch()
  const closeToast = ToastsSlice.actions.closeToast

  useEffect(() => {
    let timer: NodeJS.Timeout
    if (toast.delay) {
      timer = setTimeout(() => dispatch(closeToast(toast.id)), toast.delay)
    }
    return () => {
      if (timer) {
        clearTimeout(timer)
      }
    }
  }, [])

  return (
    <ToastContainer type={toast.type} isCross={!toast.delay}>
      <ICircle />
      <span>{toast.message}</span>
      <RenderIf condition={!toast.delay}>
        <Cross onClick={() => dispatch(closeToast(toast.id))} />
      </RenderIf>
    </ToastContainer>
  )
}
